exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nlabel[data-v-2238bb7a] {\n    font-weight: lighter;\n    font-size: .9rem;\n    margin-bottom: 0;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n.alert[data-v-2238bb7a] {\n    font-weight: lighter;\n}\n", ""]);

// exports
